export enum FundType {
  Euro = 1,
  Other = 2,
  SCPI = 3
}
